















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StepRequiresStep } from '@/interfaces/StepRequiresStep';
import { Step } from '@/interfaces/Step';
import { Requirement } from '@/types';
import { Module } from '@/interfaces/Module';

@Component({})
export default class ModuleStepListStepRequiresTabSelectRequirements extends Vue {
  @Prop()
  value?: boolean;

  @Prop()
  step!: Step;

  @Prop()
  all_steps?: Step[];

  @Prop()
  type!: 'required_by' | 'requires' | 'informs';

  @Prop()
  requriesModal?: boolean;

  @Prop()
  module_blueprint_id?: number;

  stepIdToHiddenMap: Record<number, boolean> = {};

  refreshIcons = false;

  toggleEye(event: Event, requirement: Requirement) {
    event.stopPropagation();
    this.refreshIcons = true;
    this.stepIdToHiddenMap[requirement.id] = !this.stepIdToHiddenMap[requirement.id];
    this.refreshIcons = false;
  }

  toggleStep(step: Step) {
    const stepSelected = this.requirementIds.includes(step.id);

    if (stepSelected) {
      const index = this.requirementIds.indexOf(step.id);
      const { requirementIds } = this;
      requirementIds.splice(index, 1);
      this.requirementIds = requirementIds;
    } else {
      this.requirementIds = [...this.requirementIds, step.id];
    }
  }

  get requirementIds(): number[] {
    if (this.type === 'requires')
      return this.step.requires.map((requirement) => requirement.depending_id);
    return this.step.required_by.map((requirement) => requirement.id);
  }

  set requirementIds(ids: number[]) {
    const payload: StepRequiresStep[] = [];
    ids.forEach((id) => {
      if (this.type === 'requires')
        payload.push({
          id: this.step.id,
          hidden: this.stepIdToHiddenMap[id],
          depending_id: id
        } as StepRequiresStep);
      else
        payload.push({
          id,
          hidden: this.stepIdToHiddenMap[id],
          depending_id: this.step.id
        } as StepRequiresStep);
    });

    this.$emit('setDepending', payload);
  }

  filter = '';

  get allFilteredModules() {
    if (!this.filter) return this.all_steps;
    const filteredModules = this.all_steps?.filter((module) =>
      module.steps.find((step: Step) => {
        if (!step.stepLanguages?.length) return false;
        for (const language of step.stepLanguages) {
          if (language?.name?.includes(this.filter)) {
            return true;
          }
        }
        return false;
      })
    );
    return filteredModules;
  }

  getModuleName(module: Module) {
    const preferredLanguage = module.moduleLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    return preferredLanguage?.name || module.moduleLanguages?.[0]?.name;
  }

  getStepName(step: Step) {
    const stepLanguage =
      step.stepLanguages.find((sL: any) => sL.langaugeId === this.$store.state.user.languageId) ||
      step.stepLanguages[0];
    return stepLanguage?.name || '';
  }

  getFilteredStepsFromModule(module: Module) {
    if (!this.filter) return module.steps;
    const filteredSteps = module.steps.filter((step: Step) => {
      if (!step.stepLanguages?.length) return false;
      for (const language of step.stepLanguages) {
        if (language?.name?.includes(this.filter)) {
          return true;
        }
      }
      return false;
    });
    return filteredSteps;
  }
}
